import React from 'react'
import moment from 'moment'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { SalesDiscountType } from '@/models/sales'

type ConfirmedDiscountProps = {
  index: number
  discount: SalesDiscountType
  advanceCompany?: any
  canPostClosingEdit?: boolean
  onStartPostClosingEdit?: () => void
}

export const ConfirmedDiscount: React.FC<ConfirmedDiscountProps> = ({
  index,
  discount,
  advanceCompany,
  canPostClosingEdit = false,
  onStartPostClosingEdit,
}) => {
  const { t } = useTranslation()
  return (
    <tr key={index} css={listWrapperStyle}>
      <td>{discount.salesDate && moment(discount.salesDate).format(t('MM-DD'))}</td>
      <td>{discount.salesDiscountName}</td>
      <td>{discount?.roomNumber ? `${discount.roomNumber}(${discount.guestRoomAssignShortId})` : '-'}</td>
      <td>
        {discount.companyId
          ? advanceCompany?.paymentCompanies?.find(item => item?.id === discount.companyId)?.name
          : discount.salesPaymentName}
      </td>
      <td>{Number(discount.salesSubjectPrice).toLocaleString()}</td>
      <td className="accountsReceivable">{discount.salesAccountsReceivableName || '-'}</td>
      <td css={actionCellStyle}>
        {canPostClosingEdit && onStartPostClosingEdit && (
          <button type="button" css={editButtonStyle} onClick={onStartPostClosingEdit} aria-label={t('Edit')}>
            <img alt="edit" src={require('@/static/images/memo.svg')} css={editIconStyle} />
          </button>
        )}
      </td>
    </tr>
  )
}

const listWrapperStyle = css({
  ':hover': {
    boxShadow: 'none',
    cursor: 'default',
  },
  'div.accountsReceivable': {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  td: {
    backgroundColor: '#F6F6F6',
    height: 57,
  },
})

const actionCellStyle = css({
  textAlign: 'right',
  verticalAlign: 'middle',
  paddingRight: 8,
})

const editButtonStyle = css({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
})

const editIconStyle = css({
  width: 16,
  height: 16,
})
